import {fetch} from 'utils/dataAccess'

export default async function deleteRecommendation(recommendation)  {
    const response = await fetch(recommendation['@id'], {
        method: "DELETE",
    })

    return await response
}
